import { INLINE_BUTTON_HEADER } from 'components/SEM/constants'

export const sectionData = {
  type: INLINE_BUTTON_HEADER,
  heading: 'Selected Projects',
  buttonText: 'Join them',
  hasButton: true,
}
